/**
 * Role Service — real API integration.
 * Single source of truth for role data across the entire application.
 * Endpoint: GET /api/admin/role
 */

import { authFetch, getBackendBaseUrl } from "./nodeAuthService";

/**
 * Fetch all roles from the API.
 * Returns a normalised array of  { id, name }  objects regardless of the
 * exact shape the backend sends (bare array, or common wrapper keys).
 */
export async function getRoles() {
  const url = `${getBackendBaseUrl()}/api/admin/role`;
  const res = await authFetch(url, { method: "GET" });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(
      data?.message || data?.error || `Failed to load roles (${res.status})`
    );
  }

  // Server envelope: { results: { roles: [...], pagination: {...} } }
  const list = Array.isArray(data)
    ? data
    : (data.results?.roles ?? data.roles ?? data.data ?? data.result ?? data.items ?? []);

  // Normalise to { id, name } — the shape expected by every UI component.
  // Prioritise _id (MongoDB ObjectId) over any virtual "id" field, because
  // user records store roleId as the MongoDB _id reference.
  return list.map((r) => ({
    id:   String(r._id ?? r.id ?? ""),
    name: r.name ?? r.roleName ?? r.role_name ?? r.title ?? "",
  }));
}